import { render, staticRenderFns } from "./MicrophonePermissionGuide.vue?vue&type=template&id=31b4a648&scoped=true"
import script from "./MicrophonePermissionGuide.vue?vue&type=script&lang=js"
export * from "./MicrophonePermissionGuide.vue?vue&type=script&lang=js"
import style0 from "./MicrophonePermissionGuide.vue?vue&type=style&index=0&id=31b4a648&lang=scss&scoped=true"
import style1 from "./MicrophonePermissionGuide.vue?vue&type=style&index=1&id=31b4a648&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b4a648",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zhenzhaopin\\xxh-zhaopin-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31b4a648')) {
      api.createRecord('31b4a648', component.options)
    } else {
      api.reload('31b4a648', component.options)
    }
    module.hot.accept("./MicrophonePermissionGuide.vue?vue&type=template&id=31b4a648&scoped=true", function () {
      api.rerender('31b4a648', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/audioRecorder/MicrophonePermissionGuide.vue"
export default component.exports